t = require('views/internal/teacup-with-helpers')('sticker_select')

module.exports = t.renderable ({ upgradeUrl, hasOrganization, additionalStickersEnabled, upsellEnabled }) ->
  t.div '.sticker-list.u-clearfix.js-standard-sticker-list'

  if !additionalStickersEnabled && upsellEnabled
    t.div '.sticker-ads.ads-layout-experiment', =>
      t.div '.header', =>
        t.div '.title', ->
          t.format 'ads-title'
      t.a '.learn-more', { href: '/business-class' }, ->
        t.format 'ads-learn-more'

      if hasOrganization
        t.a '.button.primary.js-upgrade-team', { href: upgradeUrl }, ->
          t.format 'ads-upgrade'
      else
        t.a '.button.primary.js-add-team', { href: '#' }, ->
          t.format 'ads-upgrade'

  if additionalStickersEnabled || upsellEnabled
    t.div '.js-premium-stickers'

    t.h2 ->
      t.format 'custom-stickers'

    t.div '.sticker-list.u-clearfix.js-custom-sticker-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/sticker_select.coffee